import React from 'react'
import Translation from '../General/Translation'
import getTranslation from '../functions/getTranslation'


const MovieSearchForm = ({
    textClass,
    translation,
    query,
    handleChange,
    handleSubmit,
}) => {
    const classNameText = textClass ? textClass : 'text-medium-navigation'
    const placeholder = getTranslation('search_the_movies', translation, 'search the movies')
    const submitText = getTranslation('searching', translation, 'search')

    return (
        <form className="search-movies" onSubmit={handleSubmit}>
            <label 
                className="search-movies-label"
                htmlFor="site-search"
            >
                <Translation id="search_the_movies" trans={translation}>Search the movies</Translation>
            </label>

            <input 
                className={"search-movies-input " + classNameText}
                type="search" 
                id="query" 
                name="query" 
                placeholder={placeholder}
                value={query}
                onChange={handleChange}
                autoFocus            
            />

            <input 
                className={"search-movies-submit " + classNameText}
                type="submit" 
                value={submitText}
            />
        </form>
    )
}

export default MovieSearchForm